export const SCROLL_THRESHOLD_PX = 150;

export const FADE_DURATION_MS = 200;

export const FRONT_CHAT_FADE_CLASS = "front-chat-fade-hidden";

export const FRONT_CHAT_STYLE_ID = "front-chat-visibility-styles";

export const FRONT_CHAT_CONTAINER_SELECTORS = [
  'iframe[src*="frontapp.com"]',
  'iframe[src*="front-chat"]',
  '[data-testid*="front"] iframe',
  '[id*="front-chat"]',
  '[class*="front-chat"]',
];

export const ensureFrontChatVisibilityStyles = () => {
  if (document.getElementById(FRONT_CHAT_STYLE_ID)) {
    return;
  }

  const style = document.createElement("style");
  style.id = FRONT_CHAT_STYLE_ID;
  style.textContent = `
    .${FRONT_CHAT_FADE_CLASS} {
      opacity: 0 !important;
      pointer-events: none !important;
      transition: opacity ${FADE_DURATION_MS}ms ease;
    }
  `;

  document.head.appendChild(style);
};

export const getFrontChatContainers = () => {
  const containers = FRONT_CHAT_CONTAINER_SELECTORS.flatMap((selector) =>
    Array.from(document.querySelectorAll<HTMLElement>(selector))
  );

  return Array.from(new Set(containers));
};

export const setFrontChatFaded = (isFaded: boolean) => {
  ensureFrontChatVisibilityStyles();

  getFrontChatContainers().forEach((container) => {
    container.style.transition = `opacity ${FADE_DURATION_MS}ms ease`;

    if (isFaded) {
      container.classList.add(FRONT_CHAT_FADE_CLASS);
    } else {
      container.classList.remove(FRONT_CHAT_FADE_CLASS);
    }
  });
};

export const checkIsSupportChatVisible = (
  routes: string[],
  pathname: string
) => {
  if (!pathname || !routes) {
    return true;
  }

  return routes.some((route) => {
    const regex = new RegExp(`(?:^|\\/)(?:${route})(?:\\/?(?:\\?.*)?$|$)`, "i");

    return regex.test(pathname);
  });
};
